import React, { useState } from "react";
import p1 from "./Media/im1.jpeg";
import p2 from "./Media/im2.jpeg";
import p3 from "./Media/im3.jpeg";
import p11 from "./Media/im11.jpeg";
import p4 from "./Media/im4.jpeg";
import p5 from "./Media/im5.jpeg";
import p6 from "./Media/im6.jpeg";
import p7 from "./Media/im7.jpeg";
import p8 from "./Media/im8.jpeg";
import p9 from "./Media/im9.jpeg";
import p10 from "./Media/im10.jpeg";
import SwipeableViews from "react-swipeable-views";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import CardsDialog from "./CardsDialog";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export default function News() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ images: [], title: "", description: "" });
  const [activeIndex, setActiveIndex] = React.useState(0);
  const { t } = useTranslation();

  const handleChangeIndex = (index) => {
    setActiveIndex(index);
  };

  const handleNext = () => {
    setActiveIndex((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveIndex((prevActiveStep) => prevActiveStep - 1);
  };
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          color: "white",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "100px",
        }}
      >
        <Typography
          sx={{
            fontSize: "35px",
            marginBottom: "50px",
          }}
        >
          {t("News and Events")}
        </Typography>
      </Box>
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "50px",
        }}
      >
        {/* <SwipeableViews index={activeIndex} onChangeIndex={handleChangeIndex} */}
        {/* style={{ padding:'50px' }}> */}

        <Card sx={{ maxWidth: 345, borderRadius: "20px", height: 450 }}>
          <img
            alt="img-1"
            style={{ height: "250px", objectFit: "fill", width: 345 }}
            src={p1}
          />
          <CardContent
            sx={{
              "&:hover": { textDecoration: "underline" },
              cursor: "pointer",
              display: "block",
              textAlign: "center",
            }}
            onClick={() => {
              setOpen(true);
              setData({
                images: [p1, p2],
                title: "Businessmen and Businesswomen Forum",
                description:
                  "From our participation in the Businessmen and Businesswomen Forum",
              });
            }}
          >
            <Typography gutterBottom variant="h5" component="div">
              {t("Businessmen and Businesswomen Forum")}
            </Typography>
            <Typography>
              {t(
                "From our participation in the Businessmen and Businesswomen Forum"
              )}
            </Typography>
          </CardContent>
        </Card>

        <Card sx={{ maxWidth: 345, borderRadius: "20px", height: 450 }}>
          <img
            alt="img-2"
            style={{ height: "250px", objectFit: "fill", width: 345 }}
            src={p4}
          />
          <CardContent
            sx={{
              display: "block",
              textAlign: "center",
              "&:hover": { textDecoration: "underline" },
              cursor: "pointer",
            }}
            onClick={() => {
              setOpen(true);
              setData({
                images: [p3, p4, p5, p6, p11],
                title: "SAS Expo exhibition",
                description:
                  "From our participation in the SAS Expo exhibition",
              });
            }}
          >
            <Typography gutterBottom variant="h5" component="div">
              {t("SAS Expo exhibition")}
            </Typography>
            <Typography>
              {t("From our participation in the SAS Expo exhibition")}
            </Typography>
          </CardContent>
        </Card>

        <Card sx={{ maxWidth: 345, borderRadius: "20px", height: 450 }}>
          <img
            alt="img-4"
            style={{ height: "250px", objectFit: "fill", width: 345 }}
            src={p8}
          />
          <CardContent
            sx={{
              "&:hover": { textDecoration: "underline" },
              cursor: "pointer",
              display: "block",
              textAlign: "center",
            }}
            onClick={() => {
              setOpen(true);
              setData({
                images: [p8, p9],
                title: "HiTech exhibition",
                description: "From our participation in the HiTech exhibition",
              });
            }}
          >
            <Typography gutterBottom variant="h5" component="div">
              {t("HiTech exhibition")}
            </Typography>
            <Typography>
              {t("From our participation in the HiTech exhibition")}
            </Typography>
          </CardContent>
        </Card>
        {/* </SwipeableViews> */}
        {/* <div style={{ position: 'absolute',bottom:'40%',left:'30px' }}>
    <Button sx={{ borderRadius: '100px', height: '30px',
     color: 'white'}}
              size="small"
              onClick={handleNext}
              disabled={activeIndex === data.images.length - 1}
          >
              <ArrowBackIosIcon />
          </Button>
          </div>
          <div style={{ position: 'absolute',bottom:'40%',right:'30px' }}>
          <Button
              sx={{  borderRadius: '100px', color: 'white',
               height: '30px' }}
              size="small" onClick={handleBack} disabled={activeIndex === 0}>
                  <ArrowForwardIosIcon />
              </Button>
              </div> */}
      </Container>
      <CardsDialog open={open} setOpen={setOpen} data={data} />
    </div>
  );
}
